

import $ from "jquery";
// import Swiper JS
import Swiper, { Navigation, Pagination, Scrollbar, Autoplay } from 'swiper';
// import Swiper styles
import 'swiper/swiper-bundle.css';

var galleryrow =  $('.gallery_slider_ded2').parent().parent().parent().parent();
galleryrow.addClass("fullwidth");




var containerEl = document.querySelector(".mix-container");


if (typeof mixitup !== "undefined" && typeof mixitup === "function") {
  var mixer = mixitup(containerEl, {
    multifilter: {
      enable: true,
    },
    animation: {
      effects: "fade translateZ(-100px)",
    },
  });
}
// var val1 = $('.gallery_slider_ded2').parent().parent().parent().parent();
// for (var i = 0; i < val1.length;  i++) {
//     val1[i].setAttribute("data-vc-full-width", 'true');
//     val1[i].setAttribute("data-vc-full-width", 'true');
//     val1[i].setAttribute("data-vc-stretch-content", 'true');
//     val1[i].setAttribute("test", 'true');
//   }

//var val2 = $('.gallery_slider_ded2').parent().parent().parent().parent().setAttribute('data-vc-full-width', 'true');
//var val3 = $('.gallery_slider_ded2').parent().parent().parent().parent().setAttribute('data-vc-stretch-content', 'true');

// configure Swiper to use modules
Swiper.use([Navigation, Pagination, Scrollbar, Autoplay]);

$('.gallery_slider_ded2').each(function(){
  var $element = $(this).find('.gallery_slider_ded2__slider');
  var $scrollbar = $(this).find('.swiper-scrollbar');
  var $pagination = $(this).find('.swiper-pagination');


  new Swiper($element[0], {
    slidesPerView: 1,
    spaceBetween: 24,
    dots: true,
    speed: 400,

    autoplay: {
      delay: 4000,
      disableOnInteraction: true,
    },
    // If we need pagination
    // pagination: {
    //   el: '.swiper-pagination',
    //   clickable: true,
    // },
    // scrollbar: {
    //   el: '.swiper-scrollbar',
    //   hide: false,
    // },
    loop: false,
    scrollbar: {
      el: $scrollbar[0],
      draggable: true,
    },
    pagination: {
      el: $pagination[0],
      clickable: true,
    },
    breakpoints: {
      1024: {
        slidesPerView: 4,
        autoplay: true,
      },
      768: {
        slidesPerView: 3,
        autoplay: true,
      },
      540: {
        slidesPerView: 2,
        autoplay: true,
      }


    }
    // Navigation arrows
    // navigation: {
    //   nextEl: '.swiper-button-next',
    //   prevEl: '.swiper-button-prev',
    // }
  
  });

  $('.gallery_slider_ded2__slide_image_inner').on('mouseenter', function(){
    var $this = $(this);
    var $slideVideo = $this.find('.card-video');
    var videoURL = $slideVideo.attr('data-video-url');
    var videoHTML = '<video autoplay muted loop><source src="' + videoURL + '" type="video/mp4"></video>';
    if(!$this.hasClass('video-added')) {
      $slideVideo.html(videoHTML);
    }
    $this.addClass('video-added');
  });
});




//  setTimeout(() => {
//    window.dispatchEvent(new Event('resize'));
//  }, 300);

function scrollbar(){
  var sliderwrapper_width = $('.gallery_slider_ded2__slider').width();
  console.log("sliderwrapper_width " + sliderwrapper_width);
  var slider_contentwidth = $('.swiper-slide');
  console.log(slider_contentwidth);

  // $(".mcs-horizontal").mCustomScrollbar({
  //   axis:"x",
  //   theme:"dark-thick",
  //   autoExpandScrollbar:true,
  //   advanced:{autoExpandHorizontalScroll:true},
  //   updateOnContentResize:true,
  //   scrollbarPosition: 'outside',
  //   scrollInertia: 200
  // });


}

scrollbar();





